export default "__VITE_ASSET__DNj7$BFB__"